import { PaymentsApi } from '../clients';

export const getACHAuthorizationRecords = async (userId) => {
  return PaymentsApi.getACHAuthorizationRecords(userId);
};
